function checkSlickNoSlide(slick) {
  var elm = $(slick).find('.collection-product-variants ul'),
      getSlick = elm.slick('getSlick');

  if(getSlick.slideCount <= getSlick.options.slidesToShow) {
    elm.addClass('slick-no-slide');
  }
  else {
    elm.removeClass('slick-no-slide');
  }
}
$(document).ready(function(){
  ankitfn = () => {
  	if($(".grid .grid__item.grid__item.grid-product").length > 0)
    {
      $(".grid .grid__item.grid__item.grid-product").each(function(){
        if($(this).find(".grid-product__content .collection-product-slider").length > 0 && $(this).find(".collection-product-variants ul").length > 0)
        {
          var collectionProduct = $(this).find('.grid-product__content .collection-product-slider');
          var collectionProductThumb = $(this).find('.collection-product-variants ul');
          $(this).find('.grid-product__content .collection-product-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            lazyLoad: 'ondemand',
            asNavFor: collectionProductThumb
          });
          $(this).find('.collection-product-variants ul').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            lazyLoad: 'progressive',
            centerMode: false,
            focusOnSelect: true,
            asNavFor: collectionProduct,
            prevArrow:"<button type='button' class='slick-prev slick-arrow' aria-label='Previous'><svg class='flickity-button-icon' viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z' class='arrow'></path></svg></button>",
            nextArrow:"<button type='button' class='slick-next slick-arrow' aria-label='Next'><svg class='flickity-button-icon' viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z' class='arrow' transform='translate(100, 100) rotate(180)'></path></svg></button>",
            responsive: [
            {
              breakpoint: 700,
              settings: {
                slidesToShow: 2
              }
            }
          ]
          });
          checkSlickNoSlide(this);
        }
      });
    }
  };
  	ankitfn();
  $(document).on("click", ".collection-product-variants li",function(){
    var currentVariantUrl = $(this).attr("data-url");
    if(typeof currentVariantUrl != "undefined" && currentVariantUrl != null && currentVariantUrl != "")
    {
      $(this).parents(".grid-product").find(".slideshow-wrapper .image-wrap a").attr("href", currentVariantUrl);
      $(this).parents(".grid-product").find(".grid-product__meta .grid-product__title a").attr("href", currentVariantUrl);
    }
  });
});